import axios from "axios";

export const Urls = {
  LOGIN_API: "/api/1/auth/login/",
  LOGOUT_API: "/api/1/cus/logout",
  LOGIN_REFRESH_API: "/api/1/auth/login/refresh/",
  USER_DETAIL_API: "/api/1/cus/auth/user/",
  USER_AUTH_PERMISSION_API: "/api/1/auth/user/permissions",
  USER_ACTIVITY: "/api/1/user-activity/",
  GET_CMS_PERMISSION_LIST_API: "/api/1/cms/permissions/",
  GET_CMS_CONTENT_TYPE: "/api/1/cms/content_type/",
  GET_CMS_GROUPS_LIST: "/api/1/cms/groups/",
  PUT_CMS_GROUP_PERMISSIONS: "/api/1/cms/groups/",
  GET_USER_LIST_API: "/api/1/users/",
  GET_USER_API: "/api/1/user/",
  GET_HEADER_API: "/api/1/header/",
  GET_FOOTER_PWA_API: "/api/1/entity/section/",
  GET_TRENDING_SEARCH_API: "/api/1/entity/trending-search/",
  GET_NEWS_API: "/api/1/user_dashboard/news-block",
  GET_EXAM_API: "/api/1/user_dashboard/exams",
  GET_NEXT_IN_SERIES_API: "/api/1/user_dashboard/exams/next-in-series",
  POST_MARK_EXAM_STATUS_API: "/api/1/user_dashboard/mark-exam-status",
  POST_MARK_NEWS_STATUS_API: "/api/1/user_dashboard/mark-news-status",
  GET_EXAM_TARGET_YEAR_API: "/api/1/user_dashboard/exam-target-years",
  GET_USER_SHORTLISTED_EXAM_API: "api/1/user_dashboard/user-shortlisted-exams",
  GET_USER_EDIT_PROFILE_API: "/api/1/user_dashboard/user-edit-profile",
  GET_USER_INTRO_LINE_API: "/api/1/user_dashboard/user-intro-line",
  GET_IDP_API: "/api/1/user_dashboard/get-idp",
  GET_PROFILE_UPDATE_CHECK_API:
    "/api/1/user_dashboard/user-profile-update-check",
  POST_COMMON_IDP_API: "/api/1/user_dashboard/post-common-idp",
  POST_EXAM_LMS_PUSH_API: "/api/1/user_dashboard/lms-push",
  GET_COLLEGES_LIST_API: "/api/1/user_dashboard/colleges-list",
  GET_COLLEGE_FLASH_QUESTION_API:
    "api/1/user_dashboard/colleges-flash-question",
  GET_COLLEGES_SEARCH_API: "api/1/user_dashboard/colleges-search",
  GET_COLLEGES_FILTER_API: "api/1/user_dashboard/colleges-filters",
  GET_COLLEGES_EXAMS_CARD_API: "api/1/user_dashboard/colleges-exam-card",
  GET_COLLEGES_SHORTLIST_API: "api/1/user_dashboard/colleges-sortlist",
  POST_COLLEGES_INTEREST_API: "api/1/user_dashboard/colleges-interest",
  USER_INFO_API: "/api/1/cus/user-detail",

  //Registration Urls
  GET_REGISTRATION_SIGNUP_DROPDOWN_FIELDS: "api/1/cus/signup",
  POST_REGISTRATION_LOGIN_OTP_API: "api/1/cus/otp-send",
  GET_REGISTRATION_USER_AUTHENTICATION_API: "api/1/cus/check-block-user",
  GET_REGISTRATION_MANAGE_CONTENT_API: "api/1/cus/manage-content",
  GET_GEOLOCATION_API: "api/1/cus/geo-loc",
  POST_SIGNUP_API: "api/1/cus/signup",
  GET_LOGIN_API: "api/1/cus/login",
  GET_CTA_MESSAGING_API: "api/1/cus/cta-messaging",
  GET_REGISTRATION_TERTIARY_CHECKBOX_API: "api/1/cus/tertiary-checkbox",
  POST_REGISTRATION_UPDATE_PROFILE_API: "api/1/cus/update-profile",
  GET_BLOCK_MAIL_DOMAIN: "api/1/cms/blocked-mail-domain",
  POST_CLEVERTAP_USER_PROFILE_API: "api/1/cus/clevertap/user-profile",
  GET_REGISTRATION_ACCOUNT_LIMIT_API: "api/1/cus/check-user-account-limit",
  GET_GOOGLE_SIGNIN_CHECK_API: "api/1/cus/google/button",
  POST_GOOGLE_SIGNIN_DATA_API : "api/1/cus/google/signup-login",
  POST_REGISTRATION_OTP_VERIFY_API: "api/1/cus/otp-verify",
  //404 url check 
  GET_404_URL_CHECK:"/api/1/4xx-url-check",
  //one click login
  GET_REGISTRATION_ONE_CLICK_USER_CHECK: "api/1/cus/1-click/check-user",
  USER_PUSH_TO_LSQ: "api/1/cus/lsq/user-push",
};
export const BASE_URL = axios?.defaults?.env?.FormData?.REACT_APP_API_URL;
